var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTesting = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.05 5a.44.44 0 0 0-.439.438v2.625c0 .241.197.437.439.437h7.9a.44.44 0 0 0 .439-.438V5.438a.44.44 0 0 0-.44-.438zm.439 2.625v-1.75h7.022v1.75z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.683 9.813a.438.438 0 0 0-.877 0v2.902l-2.89 3.404A1.748 1.748 0 0 0 8.255 19h7.489a1.76 1.76 0 0 0 1.592-1.014 1.75 1.75 0 0 0-.253-1.867l-2.89-3.404V9.813a.438.438 0 0 0-.877 0v3.062c0 .104.036.204.104.283l2.994 3.527a.874.874 0 0 1-.67 1.44h-7.49a.88.88 0 0 1-.796-.507.87.87 0 0 1 .127-.933l2.993-3.527a.44.44 0 0 0 .104-.283V9.812Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTesting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/testing.e90104e2.svg";